import { render, staticRenderFns } from "./CustomerLoginHistory.vue?vue&type=template&id=ff1de224&"
import script from "./CustomerLoginHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerLoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports